import { useNavigate } from "react-router-dom";
import "./ExploreCard.scss";
import { baseUrl } from "../../../../utils/apiData";
import ArrowBtn from "../../../../components/arrowbtn/ArrowBtn";

const ExploreCard = ({ data, j }) => {
  const navigate = useNavigate();

  return (
    <div className="explore_card wow fadeInUp" data-wow-delay={`${0.1 * j}s`}>
      <div className="img_wrap">
        <img src={`${baseUrl}/${data?.image}`} alt="img" />
      </div>
      <div className="info">
        <p className="t-14">{data?.category?.category_name || "-"}</p>
        <h4><b>{data?.name || "-"}</b></h4>
        <p className="float">{data?.small_description || "-"}</p>

        <ArrowBtn
          type="button"
          text="View more"
           theme="secondary_ternery"
          handleClick={() => navigate(`/vendors/${data?.slug}`)}
        />
      </div>
    </div>
  );
};

export default ExploreCard;
